import blockUserService from "@services/blockUser/blockUserService"
import { action, makeAutoObservable, observable } from "mobx"

class BlockUserStore {
  @observable isLoading!: boolean

  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
  }

  @action
  async blockedUser(body: any) {
    await blockUserService.blockedUser(body)
  }

  @action
  async unblockUser(body: any) {
    await blockUserService.unblockUser(body)
  }

  @action
  async increaseErrorCount(body: any) {
    await blockUserService.increaseErrorCount(body)
  }
}

export default BlockUserStore
